import { computed } from "vue"
import store from "@/store";
import {refreshSession, userLogout} from "@/services/userServices";
import {
  ACTIONS as AUTHENTICATION_ACTIONS,
  NAMESPACE as AUTHENTICATION_NAMESPACE
} from "@/constants/vuex/authentication";
import {redirect} from "@/util/router_utils";
import {LOGIN} from "@/constants/router/routes";

export const useDialogExpirationSession = () => {
  const dialogActive = computed(() => store.state.session.modalVisible)
    const continueSession = async () => {
      await refreshSession()
    }

    const closeSession = async () => {
      await userLogout()
      await store.dispatch(`${AUTHENTICATION_NAMESPACE}/${AUTHENTICATION_ACTIONS.A_SET_LOGOUT_DATA}`)
      // showToast(true, 401)
      redirect(LOGIN)
  }

      return {
        continueSession,
        closeSession,
        dialogActive
      }

}